import {
  Domains,
  PartnerPromoCodes,
  PartnerLogo,
  Partners,
  FlowType,
} from "@/core/types/types";

// Local constants
const DEFAULT_DATE_FORMAT: string = "dd.MM.yyyy";
const DEFAULT_TIME_FORMAT: string = "HH:mm";

// Primitive constants
export const DEFAULT_FLOW: FlowType = FlowType.APR;
export const FOOTER_LINKS: string[] = ["privacy", "terms", "imprint"];
export const ADDITIONAL_PASSENGER_SIGNATURES_KEY: string =
  "additionalPassengerSignatures";
export const PASSENGER_AVAILABLE_KEY: string = "passengerAvailable";
export const SAME_ADDRESS_KEY: string = "sameAddress";
export const IP_ADDRESS_FIELD: string = "ipAddress";
export const USER_AGENT_FIELD: string = "userAgent";
export const MIN_SIGNATURE_LENGTH: number = 10;
export const PURCHASE_EVENT = "cc_purchase";
export const SIGNATURE_EVENT = "customer-signature-saved";
export const PROMOTION_CODE = "promotionCode";

// Object constants
export const HOTJAR_ATTRIBUTES: any = {
  inputProps: {
    "data-hj-allow": "",
  },
};

export const dateFormats: {
  [key in keyof typeof Domains as string]: string;
} = {
  [Domains.NET]: "MM/dd/yyyy",
  [Domains.COM]: "dd/MM/yyyy",
  [Domains.UK]: DEFAULT_DATE_FORMAT,
  [Domains.DE]: DEFAULT_DATE_FORMAT,
  [Domains.AT]: DEFAULT_DATE_FORMAT,
  [Domains.ES]: "dd/MM/yyyy",
  [Domains.FR]: "dd/MM/yyyy",
  [Domains.NO]: DEFAULT_DATE_FORMAT,
  [Domains.DK]: DEFAULT_DATE_FORMAT,
  [Domains.SE]: "yyyy-MM-dd",
  [Domains.FI]: DEFAULT_DATE_FORMAT,
};

export const timeFormats: {
  [key in keyof typeof Domains as string]: string;
} = {
  [Domains.NET]: "h:mm a",
  [Domains.COM]: DEFAULT_TIME_FORMAT,
  [Domains.UK]: DEFAULT_TIME_FORMAT,
  [Domains.DE]: DEFAULT_TIME_FORMAT,
  [Domains.AT]: DEFAULT_TIME_FORMAT,
  [Domains.ES]: DEFAULT_TIME_FORMAT,
  [Domains.FR]: DEFAULT_TIME_FORMAT,
  [Domains.NO]: DEFAULT_TIME_FORMAT,
  [Domains.DK]: DEFAULT_TIME_FORMAT,
  [Domains.SE]: DEFAULT_TIME_FORMAT,
  [Domains.FI]: "HH.mm",
};

export const partnerLogoConfig: {
  [key in keyof typeof Partners as string]: PartnerLogo;
} = {
  [Partners.ADVOCARD]: {
    path: "images/logos/partners/advocard.svg",
    width: 148,
    height: 96,
    headerHeight: 50,
  },
  [Partners.ITZ]: {
    path: "images/logos/partners/itz.svg",
    width: 180,
    height: 63,
  },
  [Partners.AMD]: {
    path: "images/logos/partners/amd.svg",
    width: 180,
    height: 20,
  },
  [Partners.TFR]: {
    path: "images/logos/partners/tfr.svg",
    width: 96,
    height: 96,
    headerWidth: 50,
    headerHeight: 50,
  },
};

export const partnerPromoCodes: {
  [key in keyof typeof PartnerPromoCodes as string]: Partners;
} = {
  [PartnerPromoCodes.ADVOCARD_KUNDE]: Partners.ADVOCARD,
  [PartnerPromoCodes.ADVOCARD_AGENT]: Partners.ADVOCARD,
  [PartnerPromoCodes.ITZ]: Partners.ITZ,
  [PartnerPromoCodes.ITZ_TEST]: Partners.ITZ,
  [PartnerPromoCodes.AMD]: Partners.AMD,
  [PartnerPromoCodes.AMD_TEST]: Partners.AMD,
  [PartnerPromoCodes.TFR]: Partners.TFR,
};
